var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 전기실 관리 - 전기실 List 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function RoomView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const isMobile = props.isMobile;
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    const setParentCurTabMenu = props.setCurTabMenu;
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const [roomInfo, setRoomInfo] = useState(null);
    const [errorList, setErrorList] = useState([]);
    const { data: retRoom, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/room/detail`,
        appQuery: { roomId: curTree.room.roomId },
        userToken: userInfo.loginInfo.token,
        watch: curTree.room.roomId + curTree.reload
    });
    useEffect(() => {
        if (retRoom) {
            if (retRoom.codeNum == CONST.API_200) {
                //clog("IN ROOM : RES : " + JSON.stringify(retRoom.body));
                setParentPopWin("pop-area-right-page-info", React.createElement(MobileRoomView, { curTree: curTree, roomInfo: retRoom.body, errorList: errorList, onClickTreeOnOff: onClickTreeOnOff, onClickUpdateRoom: onClickUpdateRoom, onClickDoDeleteRoom: onClickDoDeleteRoom, onClickDeviceInsert: onClickDeviceInsert }));
                setRoomInfo(retRoom.body);
            }
            else {
                setErrorList(retRoom.body.errorList);
            }
        }
    }, [curTree, retRoom]);
    //////////////////////////////////////////////////////////////////////////
    //(roomInfo)
    //?clog("IN ROOMVIEW : INIT : roomInfo : " + JSON.stringify(roomInfo))
    //:clog("IN ROOMVIEW : INIT : roomInfo : " + "null");
    //clog("IN SITEIVEW : INIT : zoneInfo : " + (roomInfo)?JSON.stringify(roomInfo.zone):"null");
    function onClickDoDeleteRoom(e, room) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN ROOMVIEW : onClickDoDeleteRoom : " + JSON.stringify(room));
            var isOk = confirm(`${room.roomName}을(를) 삭제하시겠습니까?`);
            if (!isOk)
                return;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "productId": room.roomId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN ROOM-DELETE: ret : " + JSON.stringify(data.body));
                    alert(CONST.FLD_MSG_DELETE_COMMON);
                    setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { room: { "roomId": "", "roomName": "" } }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                    //alert(`ERROR : ${room.roomName} : ` + JSON.stringify(data.body.errorList));
                    alert(data.body.errorList[0].msg);
                }
            }
            //return data;
        });
    }
    // 기기등록 tab 및 목록으로 이동
    function onClickDeviceInsert(e) {
        e.stopPropagation();
        CUTIL.jsclose_Popup("pop-area-right-page-info");
        //mainlayout tab 데이터 확인 필요
        setParentCurTabMenu({ tabId: 1, tabName: "기기 등록 관리", tabType: "TAB_DEVICE" });
        setParentWorkMode("LIST");
        //setParentAdminType("ROOM")
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    function onClickTreeOnOff(e, room) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/product/usertree",
                appQuery: {
                    "product": "room",
                    "productId": room.roomId,
                    "approval": room.approval,
                    "isontree": !room.isontree,
                    "sort": room.sort
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    /*
                    setParentCurTree("SUBZONE", // 업데이트시 자신 호출
                      {
                        ...curTree,
                        room: { "roomId": "", "roomName": "" },
                      }
                    );
                    */
                    setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": room.roomId, "roomName": room.roomName }, reload: true }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            //return data;
        });
    }
    function onClickUpdateRoom(e, room) {
        setParentCurTree("ROOM", Object.assign(Object.assign({}, curTree), { room: { "roomId": room.roomId, "roomName": room.roomName } }));
        setParentWorkMode("UPDATE");
    }
    return (React.createElement(React.Fragment, null, (roomInfo) && React.createElement("div", { className: "area__right", ref: mobileRef },
        React.createElement("ul", { className: "page-loca" },
            React.createElement("li", null, curTree.company.companyName),
            React.createElement("li", null, curTree.zone.zoneName),
            React.createElement("li", null, curTree.subZone.subZoneName),
            React.createElement("li", null, roomInfo.roomName)),
        React.createElement("div", { className: "page-top" },
            React.createElement("h2", null, roomInfo.roomName),
            React.createElement("div", { className: "top-button" },
                React.createElement("button", { type: "button", className: "btn-edit", onClick: (e) => onClickUpdateRoom(e, roomInfo) },
                    React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDoDeleteRoom(e, roomInfo) },
                    React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
        React.createElement("div", { className: "area__right_content workplace__info" },
            React.createElement("div", { className: "content__info" },
                React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                React.createElement("ul", null,
                    (userInfo.loginInfo.role == CONST.USERROLE_ADMIN) ?
                        "" :
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "TREE"),
                            React.createElement("p", { className: `txt ${(roomInfo.isontree) ? "treeon" : "treeoff"}`, onClick: (e) => onClickTreeOnOff(e, roomInfo) },
                                React.createElement("span", { className: "hide" }, (roomInfo.isontree) ? "on" : "off")),
                            React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "isontree")).map((err) => err.msg))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                        React.createElement("p", { className: "txt" }, roomInfo.memo)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC804\uAE30\uC2E4 \uB3C4\uBA74"),
                        React.createElement("ul", { className: "filelist" }, (roomInfo.fileList) && roomInfo.fileList.map((file, idx) => (React.createElement("li", { key: `file_${idx.toString()}` },
                            React.createElement("a", { href: file.url, target: "_blank", rel: 'noreferrer' },
                                React.createElement("span", null, file.name))))))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                        React.createElement("p", { className: "txt" },
                            roomInfo.itemCount,
                            React.createElement("button", { type: "button", className: "btn-add", "data-pop": "pop-list", onClick: (e) => onClickDeviceInsert(e) },
                                React.createElement("span", null, "\uAE30\uAE30 \uB4F1\uB85D")))))),
            React.createElement("div", { className: "content__list scrollH" },
                React.createElement("div", { className: "listbox__top" },
                    React.createElement("h3", null, "\uC0AC\uC6A9\uC790 \uBAA9\uB85D")),
                React.createElement("div", { className: "tbl-list" },
                    React.createElement("table", { summary: "\uBC88\uD638,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uC774\uB984,\uD68C\uC0AC,\uC5F0\uB77D\uCC98,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC6A9\uC790 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                        React.createElement("caption", null, "\uC0AC\uC6A9\uC790 \uBAA9\uB85D"),
                        React.createElement("colgroup", null,
                            React.createElement("col", { style: {} })),
                        React.createElement("thead", null,
                            React.createElement("tr", null,
                                React.createElement("th", { scope: "col", className: "txt-center" }, "\uBC88\uD638"),
                                React.createElement("th", { scope: "col" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                                React.createElement("th", { scope: "col" }, "\uC774\uB984"),
                                React.createElement("th", { scope: "col" }, "\uD68C\uC0AC"),
                                React.createElement("th", { scope: "col" }, "\uC5F0\uB77D\uCC98"),
                                React.createElement("th", { scope: "col" }, "\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778"))),
                        React.createElement("tbody", null, roomInfo.userList.map((user, idx) => (React.createElement("tr", { key: `room_user_${idx.toString()}` },
                            React.createElement("td", { className: "txt-center" }, user.rownumber),
                            React.createElement("td", null,
                                React.createElement("span", null, (user.role == CONST.USERROLE_ADMIN) ? "Admin"
                                    : (user.role == CONST.USERROLE_ENGINEER) ?
                                        "Engineer"
                                        : (user.role == CONST.USERROLE_USER) ?
                                            "User"
                                            : "nodata")),
                            React.createElement("td", { className: "d-sm-none" }, user.userName),
                            React.createElement("td", { className: "d-sm-none" }, user.companyName),
                            React.createElement("td", { className: "d-sm-none" }, user.phoneNumber),
                            React.createElement("td", { className: "d-sm-none" }, user.updatedTime),
                            React.createElement("td", { className: "d-lm-none" },
                                React.createElement("p", null, user.userName),
                                React.createElement("p", null, user.phoneNumber)),
                            React.createElement("td", { className: "d-lm-none" },
                                React.createElement("p", null, user.companyName),
                                React.createElement("p", null, user.updatedTime)))))))))))));
}
;
export default RoomView;
function MobileRoomView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const roomInfo = props.roomInfo;
    const errorList = props.errorList;
    const onClickTreeOnOff = props.onClickTreeOnOff;
    const onClickUpdateRoom = props.onClickUpdateRoom;
    const onClickDoDeleteRoom = props.onClickDoDeleteRoom;
    const onClickDeviceInsert = props.onClickDeviceInsert;
    return (React.createElement(React.Fragment, null, (roomInfo) &&
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName),
                React.createElement("li", null, curTree.subZone.subZoneName),
                React.createElement("li", null, roomInfo.roomName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, roomInfo.roomName),
                React.createElement("div", { className: "top-button" },
                    React.createElement("button", { type: "button", className: "btn-edit", onClick: (e) => onClickUpdateRoom(e, roomInfo) },
                        React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                    React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDoDeleteRoom(e, roomInfo) },
                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
            React.createElement("div", { className: "area__right_content workplace__info" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                    React.createElement("ul", null,
                        (userInfo.loginInfo.role == CONST.USERROLE_ADMIN) ?
                            "" :
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "TREE"),
                                React.createElement("p", { className: `txt ${(roomInfo.isontree) ? "treeon" : "treeoff"}`, onClick: (e) => onClickTreeOnOff(e, roomInfo) },
                                    React.createElement("span", { className: "hide" }, (roomInfo.isontree) ? "on" : "off")),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "isontree")).map((err) => err.msg))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("p", { className: "txt" }, roomInfo.memo)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC804\uAE30\uC2E4 \uB3C4\uBA74"),
                            React.createElement("ul", { className: "filelist" }, (roomInfo.fileList) && roomInfo.fileList.map((file, idx) => (React.createElement("li", { key: `file_${idx.toString()}` },
                                React.createElement("a", { href: file.url, target: "_blank", rel: 'noreferrer' },
                                    React.createElement("span", null, file.name))))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                            React.createElement("p", { className: "txt" },
                                roomInfo.itemCount,
                                React.createElement("button", { type: "button", className: "btn-add", "data-pop": "pop-list", onClick: (e) => onClickDeviceInsert(e) },
                                    React.createElement("span", null, "\uAE30\uAE30 \uB4F1\uB85D")))))),
                React.createElement("div", { className: "content__list scrollH" },
                    React.createElement("div", { className: "listbox__top" },
                        React.createElement("h3", null, "\uC0AC\uC6A9\uC790 \uBAA9\uB85D")),
                    React.createElement("div", { className: "tbl-list" },
                        React.createElement("table", { summary: "\uBC88\uD638,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uC774\uB984,\uD68C\uC0AC,\uC5F0\uB77D\uCC98,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC0AC\uC6A9\uC790 \uBAA9\uB85D \uC785\uB2C8\uB2E4." },
                            React.createElement("caption", null, "\uC0AC\uC6A9\uC790 \uBAA9\uB85D"),
                            React.createElement("colgroup", null,
                                React.createElement("col", { style: {} })),
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", { scope: "col", className: "txt-center w12p" }, "\uBC88\uD638"),
                                    React.createElement("th", { scope: "col", className: "w12p" }, "\uC0AC\uC6A9\uC790 \uD0C0\uC785"),
                                    React.createElement("th", { scope: "col" }, "\uC774\uB984"),
                                    React.createElement("th", { scope: "col" }, "\uD68C\uC0AC"),
                                    React.createElement("th", { scope: "col" }, "\uC5F0\uB77D\uCC98"),
                                    React.createElement("th", { scope: "col" }, "\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778"))),
                            React.createElement("tbody", null, roomInfo.userList.map((user, idx) => (React.createElement("tr", { key: `room_user_${idx.toString()}` },
                                React.createElement("td", { className: "txt-center w12p" }, user.rownumber),
                                React.createElement("td", { className: "w12p" },
                                    React.createElement("span", null,
                                        " ",
                                        (user.role == CONST.USERROLE_ADMIN) ? "Admin"
                                            : (user.role == CONST.USERROLE_ENGINEER) ?
                                                "Engineer"
                                                : (user.role == CONST.USERROLE_USER) ?
                                                    "User"
                                                    : "nodata")),
                                React.createElement("td", { className: "d-sm-none" }, user.userName),
                                React.createElement("td", { className: "d-sm-none" }, user.companyName),
                                React.createElement("td", { className: "d-sm-none" }, user.phoneNumber),
                                React.createElement("td", { className: "d-sm-none" }, user.updatedTime),
                                React.createElement("td", { className: "d-lm-none" },
                                    React.createElement("p", null, user.userName),
                                    React.createElement("p", null, user.phoneNumber)),
                                React.createElement("td", { className: "d-lm-none" },
                                    React.createElement("p", null, user.companyName),
                                    React.createElement("p", null, user.updatedTime)))))))))))));
}
